/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { typography } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const Container = styled.span`
  display: inline-flex;

  /* Adds space after nav buttons if there is another div (when not sticky header, 
  there's a settings icon button to the right of these nav buttons) */
  & + div {
    margin-left: ${token('space.100', '8px')};
  }

  /* Adds space between the left and right nav buttons  */
  & > div:first-of-type {
    margin-right: ${token('space.050', '4px')};
  }
`;

export const FileNumber = styled.span`
  ${typography.h200() as any};

  align-self: center;
  margin: 0 ${token('space.100', '8px')};
  text-transform: uppercase;
`;
